/* fr-feinschliff.js - Wunsch Emre 04.11.2026, ausserhalb GLOWUP. Bitte in fr-r3 uebernehmen. */
/* auktionshaus_shop.js - Wunsch Emre 04.11.2026: im Hero von /pages/auktionshaus zweiter Knopf
   "Zum Shop" neben "Jetzt kontaktieren". Ziel = Menuepunkt "Shop" (/collections/produkte).
   Der Hero kommt aus einer Dynamic-Grid-Section ohne zweiten Knopf, daher per JS; Stil in auktionshaus_shop.css. */
(function () {
  if (!/^\/pages\/auktionshaus\/?$/.test(location.pathname)) return;
  function add() {
    var a = document.querySelector('main .shopify-section .button-group a[href="/pages/kontakt"]');
    if (!a) return false;
    var g = a.parentElement;
    if (g.querySelector('.fr-auk-shop')) return true;
    var b = document.createElement('a');
    b.className = 'button fr-btn-ghost fr-auk-shop';
    b.href = '/collections/produkte';
    b.innerHTML = '<button-content class="button__content">Zum Shop</button-content>';
    g.appendChild(b);
    return true;
  }
  function run() {
    if (add()) return;
    var mo = new MutationObserver(function () { if (add()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* fr-hero-osg.js (Wunsch Emre 04.11.2026)
   Setzt im Video-Hero neben "Jetzt kontaktieren" den Zweitknopf "Jetzt anrufen!".
   Nicht auf der Auktionshaus-Seite (dort setzt ein anderer Patch "Zum Shop") und nie
   doppelt: kein Einsetzen, wenn die Knopfzeile schon einen tel-Link oder zwei Knoepfe hat.
   Der Hero wird von fr-glow.js/fr-r3.js per JS gebaut, deshalb wartet ein
   MutationObserver hoechstens 4 s auf ".fr-hero--c .button-group". */
(function () {
  if (/auktionshaus|anundverkauf/i.test(location.pathname)) return;
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/></svg>';
  function run() {
    var g = document.querySelector('.fr-hero--c .button-group');
    if (!g) return false;
    var sec = g.closest('.fr-hero--c');
    if (!sec.querySelector('video-media, video')) return true;
    if (g.querySelector('a[href^="tel:"]') || g.querySelectorAll('a, button').length > 1) return true;
    var a = document.createElement('a');
    a.className = 'button fr-htel';
    a.href = 'tel:+49716168111';
    a.innerHTML = '<button-content class="button__content">' + ICON + '<span>Jetzt anrufen!</span></button-content>';
    g.appendChild(a);
    return true;
  }
  function start() {
    if (run()) return;
    var mo = new MutationObserver(function () { if (run()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { mo.disconnect(); }, 4000);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();


/* ===== Runde Alejandro 04.11.2026 (GLOWUP/17_Runde04, zusammengeführt): vorher ===== */

/* ----- vorher ----- */
/* ===== vorher ===== */
/* vorher.js - Wunsch Alejandro 04.11.2026, gehoert zu vorher.css (Karten im Vorher/Nachher, .fx-ba-c__th).
   "Wohnungsaufloesung" bekommt eine weiche Trennstelle, damit schmale Karten sauber "Wohnungs-/aufloesung"
   trennen statt "Wohnungsaufloe-/sung" oder "Wohnungsaufl/oesung". Ein- und zweizeilig bleibt wie vorher, nichts springt.
   fr-feinschliff.js laeuft vor fr-var.js (das die Section baut), deshalb jetzt, bei DOMContentLoaded und bei load. */
(function () {
  function run() {
    var s = document.querySelectorAll('.fx-ba-c__th button span');
    for (var i = 0; i < s.length; i++) if (s[i].textContent === 'Wohnungsauflösung') s[i].textContent = 'Wohnungs­auflösung';
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();;


/* ===== Runde Alejandro 04.11.2026 (GLOWUP/17_Runde04, zusammengeführt): einsatz ===== */

/* ----- einsatz ----- */
/* einsatz.js (Runde 04.11.2026, Thema einsatz)
   Einsatzgebiete ".fr8-gb" (gebaut in fr-r3.js: v8 baut die Pillen, deMap die SVG-Karte):
   - Hover über eine Ortspille: Karte zoomt weich auf Baden-Württemberg, der Ort leuchtet auf
     (Punkt groß und hell, Lichthof, Name im Stil der Göppingen-Beschriftung).
   - Wechsel zu einer anderen Pille: Karte bleibt gezoomt, der Lichthof gleitet zum neuen Ort.
   - Maus verlässt alle Pillen: 2,8 s bleibt alles stehen, dann zoomt die Karte weich heraus.
   - Nur auf Geräten mit Hover (dazu Tastaturfokus per :focus-visible). Touch: kein Zoom.
   - prefers-reduced-motion: kein Zoom, nur die Hervorhebung.
   Zoom: Gruppe um die Umrisslinie wird skaliert; Punkte, Göppingen und Beschriftungen werden
   nur verschoben (bleiben gleich groß), die Linienstärke wird pro Bild zurückgerechnet.
   Projektion der Karte (aus den 19 Punkten in fr-r3.js nachgerechnet, alle Punkte < 0,5 Einheiten):
   x = 62.644 * Länge - 363.24, y = 5506.27 - 99.923 * Breite.
   Dazu: Lichtpunkt am Zeiger für alle Pillen der Section und der SEO-Box "Unsere Leistungen".
   Wartet per MutationObserver, bis fr-r3.js gebaut hat. Bindet nichts doppelt. */
(function () {
  if (window.frEz) return; window.frEz = 1;
  var NS = 'http://www.w3.org/2000/svg';
  function mq(q) { try { return matchMedia(q); } catch (e) { return { matches: false }; } }
  var HOV = mq('(hover: hover)'), RED = mq('(prefers-reduced-motion: reduce)');
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(s) { s = String(s || '').replace(/\s+/g, ' ').trim(); try { s = s.normalize('NFC'); } catch (e) {} return s.toLowerCase(); }
  function proj(lat, lon) { return [62.644 * lon - 363.24, 5506.27 - 99.923 * lat]; }
  /* Baden-Württemberg: Breite 47,53 bis 49,79, Länge 7,51 bis 10,50 */
  var BWa = proj(49.79, 7.51), BWb = proj(47.53, 10.50);
  var ZC = [(BWa[0] + BWb[0]) / 2, (BWa[1] + BWb[1]) / 2], ZH = (BWb[1] - BWa[1]) + 64;
  var HOLD = 2800, DIN = 1050, DOUT = 1150, DMOVE = 650;
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function mk(tag, at, parent) { var e = document.createElementNS(NS, tag); for (var k in at) e.setAttribute(k, at[k]); if (parent) parent.appendChild(e); return e; }
  function visName(a) { var c = a.cloneNode(true); qa('.fr-vh', c).forEach(function (x) { x.parentNode.removeChild(x); }); return c.textContent; }
  function fv(a) { try { return a.matches(':focus-visible'); } catch (e) { return true; } }

  /* ---------- Karte ---------- */
  function MapCtl(svg) {
    var vb = svg.viewBox && svg.viewBox.baseVal; if (!vb || !vb.height) return null;
    var path = svg.querySelector('.fr-de__o'); if (!path) return null;
    var VC = [vb.x + vb.width / 2, vb.y + vb.height / 2], Z1 = Math.max(1.5, Math.min(3.2, vb.height / ZH));
    var F = [(Z1 * ZC[0] - VC[0]) / (Z1 - 1), (Z1 * ZC[1] - VC[1]) / (Z1 - 1)]; /* fester Punkt der Streckung */
    var P = [], places = {};
    function wrap(nodes, x, y, cls) {
      var g = mk('g', { 'class': 'fr-ez__p' + (cls ? ' ' + cls : '') }); nodes[0].parentNode.insertBefore(g, nodes[0]);
      nodes.forEach(function (n) { g.appendChild(n); }); P.push({ g: g, x: x, y: y }); return g;
    }
    var gz = mk('g', { 'class': 'fr-ez__z' }); path.parentNode.insertBefore(gz, path); gz.appendChild(path);
    qa('.fr-de__f', svg).forEach(function (c) { wrap([c], +c.getAttribute('cx'), +c.getAttribute('cy')); });
    qa('.fr-de__d', svg).forEach(function (c) {
      var t = c.querySelector('title'), n = t ? t.textContent : '', x = +c.getAttribute('cx'), y = +c.getAttribute('cy');
      wrap([c], x, y); if (n) places[norm(n)] = { n: n, x: x, y: y, dot: c };
    });
    var ring = svg.querySelector('.fr-de__ring'), hq = svg.querySelector('.fr-de__hq'), hql = svg.querySelector('.fr-de__l');
    if (hq) {
      var hx = +hq.getAttribute('cx'), hy = +hq.getAttribute('cy');
      wrap([ring, hq, hql].filter(Boolean), hx, hy, 'fr-ez__hq');
      places[norm('Göppingen')] = { n: 'Göppingen', x: hx, y: hy, dot: hq, hq: true };
    }
    var defs = svg.querySelector('defs') || mk('defs', {}, svg), gr = mk('radialGradient', { id: 'frez-g' }, defs);
    mk('stop', { offset: '0', 'stop-color': '#d4e5ff', 'stop-opacity': '.75' }, gr);
    mk('stop', { offset: '.4', 'stop-color': '#6aa6ff', 'stop-opacity': '.32' }, gr);
    mk('stop', { offset: '1', 'stop-color': '#6aa6ff', 'stop-opacity': '0' }, gr);
    var halo = mk('g', { 'class': 'fr-ez__hl', 'aria-hidden': 'true' }); gz.parentNode.insertBefore(halo, gz.nextSibling);
    mk('circle', { 'class': 'fr-ez__glow', r: 38, fill: 'url(#frez-g)' }, halo);
    mk('circle', { 'class': 'fr-ez__pulse', r: 17 }, halo);
    var lay = mk('g', { 'class': 'fr-ez__lab', 'aria-hidden': 'true' }, svg);
    svg.classList.add('fr-ez');

    var z = 0, zFrom = 0, zTo = 0, zT0 = 0, zDur = 1, h = null, hFrom = null, hTo = null, hT0 = 0, cur = null, raf = 0, timer = 0;
    function apply() {
      var Z = Math.pow(Z1, z), tx = (1 - Z) * F[0], ty = (1 - Z) * F[1];
      if (z > 0) { gz.setAttribute('transform', 'matrix(' + Z.toFixed(4) + ' 0 0 ' + Z.toFixed(4) + ' ' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ')'); path.style.strokeWidth = (2 / Z).toFixed(3) + 'px'; }
      else { gz.removeAttribute('transform'); path.style.removeProperty('stroke-width'); }
      for (var i = 0; i < P.length; i++) {
        var q = P[i];
        if (z > 0) q.g.setAttribute('transform', 'translate(' + ((Z - 1) * (q.x - F[0])).toFixed(2) + ' ' + ((Z - 1) * (q.y - F[1])).toFixed(2) + ')');
        else q.g.removeAttribute('transform');
      }
      if (h) halo.setAttribute('transform', 'translate(' + (tx + Z * h[0]).toFixed(2) + ' ' + (ty + Z * h[1]).toFixed(2) + ')');
    }
    function frame(now) {
      raf = 0; var busy = false;
      if (z !== zTo) { var t = Math.min(1, (now - zT0) / zDur); z = t < 1 ? zFrom + (zTo - zFrom) * ease(t) : zTo; busy = busy || t < 1; }
      if (hTo && h && (h[0] !== hTo[0] || h[1] !== hTo[1])) { var u = Math.min(1, (now - hT0) / DMOVE), e = ease(u); h = u < 1 ? [hFrom[0] + (hTo[0] - hFrom[0]) * e, hFrom[1] + (hTo[1] - hFrom[1]) * e] : hTo.slice(); busy = busy || u < 1; }
      apply(); if (busy) raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    function zoomTo(v) {
      if (RED.matches) v = 0; if (v === zTo && (z === v || raf)) return;
      zFrom = z; zTo = v; zT0 = performance.now(); zDur = (v > z ? DIN : DOUT) * Math.max(.4, Math.abs(v - z)); kick();
    }
    function ready() { svg.classList.add('fr-ez-rdy'); }
    var box = svg.closest('.fr8-gb__map');
    function inWatch() { setTimeout(ready, 4300); }
    if (!box || box.classList.contains('in')) inWatch();
    else { var bo = new MutationObserver(function () { if (box.classList.contains('in')) { bo.disconnect(); inWatch(); } }); bo.observe(box, { attributes: true, attributeFilter: ['class'] }); }
    /* Beschriftung: wie GÖPPINGEN rechts oben vom Punkt. In der Endlage darf sie nicht über den
       Göppingen-Punkt laufen und nicht aus der Karte ragen, sonst links oben, rechts unten, links unten. */
    function label(p) {
      if (p.hq) return null;
      if (!p.lab) { var g = mk('g', { 'class': 'fr-ez__p' }, lay), t = mk('text', { 'class': 'fr-ez__l', x: p.x + 18, y: p.y - 16 }, g); t.textContent = p.n.toLocaleUpperCase('de-DE'); P.push({ g: g, x: p.x, y: p.y }); p.lab = t; }
      var r = svg.getBoundingClientRect(), s = Math.min(r.width / vb.width, r.height / vb.height) || 1;
      var fs = Math.max(26, 12 / s), k = fs / 26; /* am Bildschirm nie unter 12 px (schmale Karte ab 768 px) */
      var t2 = p.lab, w = 0; t2.style.fontSize = fs.toFixed(1) + 'px'; t2.style.strokeWidth = (5 * k).toFixed(1) + 'px';
      t2.setAttribute('text-anchor', 'start'); t2.setAttribute('x', p.x + 18 * k); t2.setAttribute('y', p.y - 16 * k);
      try { w = t2.getComputedTextLength(); } catch (e) {}
      var Zf = RED.matches ? 1 : Z1, ox = (1 - Zf) * F[0], oy = (1 - Zf) * F[1], sx = ox + Zf * p.x, sy = oy + Zf * p.y;
      var x0 = VC[0] - r.width / s / 2 + 6, x1 = VC[0] + r.width / s / 2 - 6, y0 = VC[1] - r.height / s / 2 + 6, y1 = VC[1] + r.height / s / 2 - 6;
      var hqp = hq ? [ox + Zf * hx, oy + Zf * hy] : null, best = null;
      var away = hqp && Math.abs(hqp[1] - sy) < 60 * k && Math.abs(hqp[0] - sx) < w + 40 * k ? (hqp[0] > sx ? -1 : 1) : 1; /* Göppingen nah: Seite weg von Göppingen */
      [[away, -1], [-away, -1], [away, 1], [-away, 1]].forEach(function (c) {
        if (best && best.ok) return;
        var bx0 = c[0] > 0 ? sx + 18 * k : sx - 18 * k - w, by1 = c[1] < 0 ? sy - 16 * k : sy + 38 * k, bx1 = bx0 + w, by0 = by1 - 21 * k;
        var inb = bx0 >= x0 && bx1 <= x1 && by0 >= y0 && by1 + 6 <= y1;
        var hit = hqp && hqp[0] + 16 > bx0 && hqp[0] - 16 < bx1 && hqp[1] + 16 > by0 - 3 && hqp[1] - 16 < by1 + 6;
        var cand = { c: c, ok: inb && !hit };
        if (!best || cand.ok || (!best.inb && inb)) { best = cand; best.inb = inb; }
      });
      var c = best.c;
      if (c[0] < 0) { t2.setAttribute('text-anchor', 'end'); t2.setAttribute('x', p.x - 18 * k); }
      t2.setAttribute('y', c[1] < 0 ? p.y - 16 * k : p.y + 38 * k);
      return t2;
    }
    function show(key) {
      var p = places[key]; if (!p) return false;
      clearTimeout(timer); ready();
      if (cur !== p) {
        var vis = svg.classList.contains('fr-ez-vis');
        if (cur) { cur.dot.classList.remove('fr-ez-on'); if (cur.lab) cur.lab.classList.remove('is-on'); }
        cur = p; p.dot.classList.add('fr-ez-on');
        var t = label(p); if (t) t.classList.add('is-on');
        svg.classList.toggle('fr-ez-oth', !p.hq);
        if (!vis || !h || RED.matches) { h = [p.x, p.y]; hTo = h.slice(); }
        else { hFrom = h.slice(); hTo = [p.x, p.y]; hT0 = performance.now(); }
        svg.classList.add('fr-ez-vis');
      }
      zoomTo(1); apply(); kick(); return true;
    }
    function hide() {
      clearTimeout(timer);
      if (cur) { cur.dot.classList.remove('fr-ez-on'); if (cur.lab) cur.lab.classList.remove('is-on'); }
      cur = null; svg.classList.remove('fr-ez-vis', 'fr-ez-oth'); zoomTo(0);
    }
    function leave() { if (!cur && !zTo) return; clearTimeout(timer); timer = setTimeout(hide, HOLD); }
    return { show: show, leave: leave, hide: hide, has: function (k) { return !!places[k]; }, svg: svg };
  }

  /* ---------- Pillen: Lichtpunkt am Zeiger ---------- */
  function light(cont) {
    if (!cont || cont.dataset.ezl) return; cont.dataset.ezl = '1';
    cont.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var a = e.target && e.target.closest ? e.target.closest('a') : null; if (!a || !cont.contains(a)) return;
      var r = a.getBoundingClientRect(); if (!r.width) return;
      a.style.setProperty('--ezx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      a.style.setProperty('--ezy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
  }

  /* ---------- Section binden ---------- */
  function bind(gb) {
    var svg = gb.querySelector('.fr8-gb__map svg.fr-de'), pills = qa('.fr8-gb__cloud a', gb);
    if (!svg || !pills.length || svg.dataset.ez) return !!(svg && svg.dataset.ez);
    if (!HOV.matches) return false; /* Touch: nichts umbauen, Pillen bleiben reine Links */
    svg.dataset.ez = '1';
    var M = MapCtl(svg); if (!M) return true;
    pills.forEach(function (a) {
      if (a.dataset.ez) return; a.dataset.ez = '1';
      var key = norm(visName(a));
      a.addEventListener('pointerenter', function (e) { if (e.pointerType === 'touch' || !HOV.matches) return; if (!M.show(key)) M.leave(); });
      a.addEventListener('pointerleave', function (e) { if (e.pointerType === 'touch') return; M.leave(); });
      a.addEventListener('focus', function () { if (HOV.matches && fv(a) && !M.show(key)) M.leave(); });
      a.addEventListener('blur', function () { M.leave(); });
    });
    window.frEzMaps = (window.frEzMaps || []).concat(M);
    return true;
  }
  var done = false;
  function scan() {
    var ok = true;
    qa('.fr8-gb').forEach(function (gb) { if (!bind(gb)) ok = false; light(gb.querySelector('.fr8-gb__cloud')); });
    qa('.fr8-sc__lk').forEach(light);
    return ok && !!document.querySelector('.fr8-gb .fr-de.fr-ez');
  }
  var t0 = 0, mo = null;
  function tick() { t0 = 0; if (scan() && document.readyState === 'complete' && mo) { mo.disconnect(); mo = null; done = true; } }
  function later() { if (!t0) t0 = setTimeout(tick, 60); }
  function start() {
    tick(); if (done) return;
    if (window.MutationObserver) { mo = new MutationObserver(later); mo.observe(document.documentElement, { childList: true, subtree: true }); }
    addEventListener('load', function () { setTimeout(tick, 0); setTimeout(tick, 1500); setTimeout(function () { if (mo) { mo.disconnect(); mo = null; } }, 12000); });
  }
  if (HOV.addEventListener) HOV.addEventListener('change', function () { if (HOV.matches) scan(); else (window.frEzMaps || []).forEach(function (m) { m.hide(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();;


/* ===== Runde Alejandro 04.11.2026 (GLOWUP/17_Runde04, zusammengeführt): hoverrest ===== */

/* ----- hoverrest ----- */
/* hover.js - Runde 04.11.2026 (Wunsch Alejandro): Pfeil "Alle ansehen" in der Google-Pille (.fx-score, gebaut von fr-var.js)
   bekommt ein eigenes span.fx-score__arr, damit er sich beim Hover per transform bewegen kann (Stil in hover.css).
   Text bleibt gleich ("Alle ansehen " plus Pfeil). Als Ersetzung in fr-var.js nicht testbar: Shopify liefert die Datei
   minifiziert aus (Pfeil als →, andere Anfuehrungszeichen). Wartet hoechstens 6 s auf die Pille, nie doppelt. */
(function () {
  function wrap() {
    var ems = document.querySelectorAll('.fx-score em'), done = ems.length > 0;
    for (var i = 0; i < ems.length; i++) {
      var em = ems[i];
      if (em.querySelector('.fx-score__arr')) continue;
      var t = em.lastChild;
      if (!t || t.nodeType !== 3 || !/→\s*$/.test(t.nodeValue)) continue;
      t.nodeValue = t.nodeValue.replace(/\s*→\s*$/, ' ');
      var s = document.createElement('span');
      s.className = 'fx-score__arr';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '→';
      em.appendChild(s);
    }
    return done;
  }
  function start() {
    if (wrap()) return;
    var mo = new MutationObserver(function () { if (wrap()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 6000);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();;


/* ===== Runde Alejandro 04.11.2026 (GLOWUP/17_Runde04, zusammengeführt): beratung2 ===== */

/* ----- beratung2 ----- */
/* beratung2.js (Variante 2 "Ticket", gewaehlt von Alejandro 04.11.2026): baut die Section
   "Kostenlose Beratung" bzw. "Unverbindliche Beratung" auf allen Seiten neu, auf denen fr-var.js sie als
   .fx-ber--b baut (Startseite, Haushaltsaufloesungs-, Entruempelungs- und Werkstatt-Staedteseiten,
   Leistungsseiten mit "Beratung" in der Ueberschrift).
   Alle Inhalte (Kicker, Ueberschrift, Text, Knopf mit Link, Foto) kommen aus der Original-Section im DOM,
   jede Seite behaelt ihre Texte und ihr Foto. Zusatz: Besichtigung, Festpreis, besenrein, Google 4,7 (57),
   Knopf mit der Nummer 07161 68111. Kein Text und kein Kasten liegt auf dem Foto.
   beratung2.css blendet .fx-ber--b sofort aus; hier wird die Klasse getauscht, dann ist die neue Fassung sichtbar.
   fr-feinschliff.js laeuft vor fr-var.js, deshalb wartet ein MutationObserver auf die Section. */
(function () {
  var TEL = 'tel:+49716168111', NR = '07161 68111';
  var G = { r: 4.7, n: 57, url: 'https://maps.google.com/?cid=17038702594987811305' };
  var USP = [['haus', 'Kostenlose Besichtigung vor Ort'], ['blatt', 'Festpreis inklusive Entsorgung'], ['besen', 'Besenreine Übergabe']];

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function txt(e) { return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }

  var IC = {
    chk: '<path d="M5 12.5l4.2 4L19 7"/>',
    haus: '<path d="M3 11l9-7 9 7"/><path d="M5 9.5V20h6"/><circle cx="16" cy="16" r="3.2"/><path d="M18.4 18.4L21 21"/>',
    blatt: '<path d="M6.5 3h8l4 4v14h-12z"/><path d="M14.5 3v4h4"/><path d="M9.5 14l2 2 3.5-4"/>',
    besen: '<path d="M17.5 2.5l-5 9"/><path d="M8.6 10.4l6.8 3.8-2.9 7.3-8.5-4.7z"/><path d="M7.8 18.9l2.4-4.6M10.6 20.4l2.1-4.2"/>',
    tel: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/>'
  };
  function ic(n) { return '<svg class="frb-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + IC[n] + '</svg>'; }
  var GLOGO = '<svg class="frb-glogo" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>';
  function sterne(r) {
    var o = '<span class="frb-stars" role="img" aria-label="' + String(r).replace('.', ',') + ' von 5 Sternen">';
    for (var i = 0; i < 5; i++) { var f = Math.max(0, Math.min(1, r - i)), id = 'frbs' + i; o += '<svg viewBox="0 0 16 16" aria-hidden="true"><defs><linearGradient id="' + id + '"><stop offset="' + f + '" stop-color="#f5b301"/><stop offset="' + f + '" stop-color="#d9e1ea"/></linearGradient></defs><path d="M8 1.2l2.1 4.3 4.7.7-3.4 3.3.8 4.7L8 12l-4.2 2.2.8-4.7L1.2 6.2l4.7-.7z" fill="url(#' + id + ')"/></svg>'; }
    return o + '</span>';
  }

  /* Text in ganze Saetze teilen (Abkuerzungen wie "z. B." bleiben zusammen) */
  function saetze(t) {
    var out = [], buf = '';
    (t.match(/[^.!?]+[.!?]+\s*|[^.!?]+$/g) || [t]).forEach(function (s) {
      buf += s;
      if (/(?:^|[\s(])(?:[a-zäöü]{1,2}|B|Nr|Str|bzw|ca|inkl|evtl|ggf|usw)\.\s*$/.test(buf)) return;
      out.push(buf.trim()); buf = '';
    });
    if (buf.trim()) out.push(buf.trim());
    return out;
  }
  /* Ganze Saetze statt Abschneiden mitten im Wort: bis "kurz" immer, bis "lang" nur auf breiten Bildschirmen (.frb-more).
     Beginnt der Text mit einer Frage, kommt der naechste Satz dazu; am Handy entfaellt die Frage (.frb-q).
     Der volle Text bleibt in der ausgeblendeten Original-Section im HTML. */
  function lead(t, kurz, lang) {
    var s = saetze(t), a = s[0] || '', b = '', i = 1, q = '';
    if (/\?$/.test(a) && s[1]) { q = a; a = s[1]; i = 2; }
    for (; i < s.length && (q + ' ' + a + ' ' + s[i]).length <= kurz; i++) a += ' ' + s[i];
    for (; i < s.length && (q + ' ' + a + ' ' + b + ' ' + s[i]).length <= lang; i++) b += (b ? ' ' : '') + s[i];
    return (q ? '<span class="frb-q">' + esc(q) + ' </span>' : '') + esc(a) + (b ? '<span class="frb-more"> ' + esc(b) + '</span>' : '');
  }

  /* Bild vom Shopify-CDN in mehreren Breiten */
  function basis(src) { src = src.replace(/&amp;/g, '&'); if (src.indexOf('//') === 0) src = 'https:' + src; return src.replace(/([?&])width=\d+(&?)/, function (m, a, b) { return b ? a : ''; }); }
  function mitBreite(b, w) { return b + (b.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function bild(d) {
    var b = basis(d.src);
    return '<img class="frb2-img" data-frb-img="' + d.art + '" src="' + mitBreite(b, 900) + '" srcset="' + [500, 700, 900, 1200, 1600].map(function (w) { return mitBreite(b, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="(max-width: 799px) calc(100vw - 64px), 560px" alt="' + esc(d.alt) + '" loading="lazy" decoding="async">';
  }
  /* Bildausschnitt: team = Gruppenfoto, peter = Peter Fritsch mit Daumen (Gesicht bei 52 % / 39 %) */
  function art(src) {
    if (/Team-Haushaltsaufloesung/i.test(src)) return 'team';
    if (/(Entruempelung|Betriebsaufloesung|Tatortreinigung)_CTA/i.test(src)) return 'peter';
    return 'std';
  }

  function daten(mount) {
    var sec = mount.closest('.shopify-section') || document;
    function orig(s) { var l = sec.querySelectorAll(s); for (var i = 0; i < l.length; i++) if (!l[i].closest('.fx')) return l[i]; return null; }
    var img = orig('img'), a = orig('a.button'), box = orig('.max-w-sm'), ps = [];
    if (box) Array.prototype.forEach.call(box.querySelectorAll('p'), function (p) { var t = txt(p); if (t) ps.push(t); });
    var src = img ? (img.getAttribute('src') || img.currentSrc || '') : '';
    if (!src) { var bg = mount.querySelector('[style*="--bg"]'); src = bg ? ((bg.getAttribute('style').match(/url\(['"]?([^'")]+)/) || [])[1] || '') : ''; }
    var d = { sub: txt(orig('.subheading')), h: txt(orig('.h3, h2')), p: ps.join(' '), href: a ? a.getAttribute('href') : '/pages/kontakt', b: txt(a) || 'Jetzt Kontakt aufnehmen', src: src, alt: img ? img.alt : '' };
    if (!d.h) d.h = txt(mount.querySelector('.fx-h'));
    if (!d.sub) d.sub = txt(mount.querySelector('.fx-kicker'));
    if (!d.p) d.p = txt(mount.querySelector('p'));
    d.art = art(d.src);
    return d;
  }

  function html(d) {
    return '<div class="fx-container"><div class="frb2">' +
      '<div class="frb2-head"><span class="fx-kicker">' + esc(d.sub) + '</span><h2 class="h3 fx-h">' + esc(d.h) + '</h2></div>' +
      '<div class="frb2-wrap frb-up" style="--d:0"><div class="frb2-t">' +
        '<div class="frb2-stub">' + (d.src ? bild(d) : '') + '</div>' +
        '<i class="frb2-perf" aria-hidden="true"></i>' +
        '<div class="frb2-body">' +
          '<span class="frb2-seal frb-up" style="--d:2">' + ic('chk') + 'Kostenlos und unverbindlich</span>' +
          '<p class="frb2-p frb-up" style="--d:3">' + lead(d.p, 190, 340) + '</p>' +
          '<ul class="frb2-usp frb-up" style="--d:4">' + USP.map(function (u) { return '<li><i>' + ic(u[0]) + '</i><span>' + u[1] + '</span></li>'; }).join('') + '</ul>' +
          '<div class="frb2-cta frb-up" style="--d:5"><a class="fx-btn frb2-b1" href="' + esc(d.href) + '">' + esc(d.b) + '</a>' +
            '<a class="fx-btn fx-btn--ghost frb2-b2" href="' + TEL + '" aria-label="Jetzt anrufen: ' + NR + '">' + ic('tel') + '<span>' + NR + '</span></a></div>' +
          '<a class="frb2-g frb-up" style="--d:6" href="' + G.url + '" target="_blank" rel="noopener">' + GLOGO + '<b>' + String(G.r).replace('.', ',') + '</b>' + sterne(G.r) + '<span>' + G.n + ' Google-Bewertungen</span></a>' +
        '</div>' +
      '</div></div>' +
    '</div></div>';
  }

  /* Dezentes Einblenden beim Einscrollen; steht die Section schon im Bild, kein Einblenden */
  function bewegung(root) {
    if ((window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || !('IntersectionObserver' in window)) return;
    var box = root.querySelector('.frb2-wrap'), r = box.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0) return;
    root.classList.add('frb-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('frb-in'); io.disconnect(); } });
    }, { threshold: 0.18 });
    io.observe(box);
  }

  function bau(mount) {
    if (mount.dataset.frb) return; mount.dataset.frb = '2';
    try {
      var d = daten(mount);
      mount.innerHTML = html(d);
      mount.className = 'fx fx-ber frb';
      bewegung(mount);
    } catch (e) {
      mount.style.visibility = 'visible';
      if (window.console) console.warn('beratung2', e);
    }
  }

  function los() { var m = document.querySelector('.fx-ber--b'); if (m) { bau(m); return true; } return false; }
  function start() {
    if (los()) return;
    var mo = new MutationObserver(function () { if (los()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
  start();
})();;
